import { mapGetters, mapActions } from 'vuex'

export const Projects = {
  data: () => ({
    projectId: null
  }),

  computed: {
    ...mapGetters(['getProjectById', 'getBoardsByProjectId']),

    /**
     * @returns {object}
     */
    project () {
      return this.getProjectById(this.projectId)
    },

    /**
     * @returns {object}
     */
    boards () {
      return this.getBoardsByProjectId(this.projectId)
    },

    /**
     * @returns {boolean}
     */
    hasBoards () {
      return this.boards.length > 0
    },

    /**
     * @returns {string}
     */
    headerTitle () {
      return this.project ? this.project.name : ''
    }
  },

  created () {
    this.projectId = parseInt(this.$route.params.id)
  },

  methods: {
    ...mapActions(['updateSelectedGroupId', 'updateSelectedSeasonId']),

    /**
     * @param {object} project
     */
    updateSelectedGroupIdAndSelectedSeasonId (project) {
      if (project) {
        const groupId = project.group ? project.group.id : null
        const seasonId = project.season ? project.season.id : null

        if (groupId && seasonId) {
          this.updateSelectedGroupId({
            groupId
          })
          this.updateSelectedSeasonId({
            seasonId
          })
        }
      }
    },

    /**
     * @param   {number}        projectId
     *
     * @returns {number | null}
     */
    getActiveBoardIdDefault (projectId) {
      if (this.boards.length > 0) {
        const defaultActiveBoardId = this.boards[0].id

        return (
          parseInt(localStorage.getItem(`activeBoard-${this.projectId}`)) ||
          defaultActiveBoardId
        )
      } else {
        return null
      }
    }
  }
}
